import { Sparkles, Loader2 } from "lucide-react";

// A.5.4E — Panneau post-vol READ-ONLY partagé (Diagnostic Drone + Journal). HISTORIQUE uniquement :
// n'affiche jamais l'état LIVE actuel. Aucune capacité d'action ; onGenerate déclenche seulement une
// requête de synthèse (le parent choisit l'endpoint : dernière orchestration OU session précise).
const yn = (v) => (v === true ? "oui" : v === false ? "non" : "—");

const Row = ({ k, v, ok }) => (
  <div className="flex items-center justify-between gap-3 py-0.5">
    <span className="text-[10px] uppercase tracking-wider text-white/40">{k}</span>
    <span className="font-mono text-[11px]" style={{ color: ok === true ? "#22C55E" : ok === false ? "#EF4444" : "#E5E5E5" }}>{v}</span>
  </div>
);

export function PostflightOrchestrationPanel({
  orchestration: lo,
  title = "Dernière orchestration",
  subtitle = "(historique — pas l'état live)",
  summary,
  loading,
  onGenerate,
  generateLabel = "Synthèse post-vol",
  unavailableText = "Aucune orchestration enregistrée pour ce drone.",
  containerTestid = "postflight-panel",
  buttonTestid = "postflight-summary-btn",
  resultTestid = "postflight-result",
  noOrchTestid = "postflight-no-orchestration",
}) {
  const tk = lo?.takeoff || {};
  const ob = lo?.offboard || {};
  const po = lo?.pilot_override || {};
  return (
    <div data-testid={containerTestid} className="rounded-sm border border-white/10 p-4">
      <div className="text-[11px] uppercase tracking-wider text-white/60 mb-2">
        {title} <span className="text-white/30">{subtitle}</span>
      </div>
      {!lo ? (
        <p data-testid={noOrchTestid} className="text-[11px] text-white/40">{unavailableText}</p>
      ) : (
        <>
          <div className="space-y-0.5">
            {lo.drone_id && <Row k="Drone" v={lo.drone_id} />}
            <Row k="Session" v={lo.session_id || "—"} />
            <Row k="Début" v={lo.started_at || "—"} />
            <Row k="Fin" v={lo.ended_at || "—"} />
            <Row k="ARM" v={yn(lo.arm?.executed)} ok={lo.arm?.executed} />
            <Row k="TAKEOFF" v={yn(tk.executed)} ok={tk.executed} />
            <Row k="TAKEOFF → LOITER" v={tk.loiter_confirmed ? "Confirmé" : "Non confirmé"} ok={!!tk.loiter_confirmed} />
            <Row k="STABILIZING" v={yn(ob.stabilizing_reached)} ok={ob.stabilizing_reached} />
            <Row k="PRESTREAM" v={yn(ob.prestream_reached)} ok={ob.prestream_reached} />
            <Row k="OFFBOARD" v={ob.active_reached ? "Acquis" : "Non acquis"} ok={!!ob.active_reached} />
            <Row k="PILOT OVERRIDE" v={po.occurred ? `oui${po.at ? " · " + po.at : ""}` : "non"} ok={po.occurred ? false : undefined} />
            <Row k="Outcome" v={lo.outcome || "—"} />
            {lo.failure_reason && <Row k="Failure reason" v={lo.failure_reason} ok={false} />}
          </div>
          {onGenerate && (
            <button data-testid={buttonTestid} onClick={onGenerate} disabled={loading}
              className="mt-3 flex items-center gap-1.5 font-mono text-[11px] uppercase tracking-wider border border-white/15 rounded-sm px-3 py-2 hover:bg-white/10 disabled:opacity-40">
              {loading ? <Loader2 size={13} className="animate-spin" /> : <Sparkles size={13} />} {generateLabel}
            </button>
          )}
          {summary && (
            <pre data-testid={resultTestid} className="mt-3 whitespace-pre-wrap text-[11px] text-white/80 bg-black/30 rounded-sm p-3 border border-white/10">{summary}</pre>
          )}
        </>
      )}
    </div>
  );
}
